// Map two-letter codes to full names and icons
const LANGUAGE_DETAILS = {
  cs: { name: 'CS', short: 'Čeština', lan: 'Czech', icon: 'flag-icon-cz' },
  da: { name: 'DA', short: 'Dansk', lan: 'Danish', icon: 'flag-icon-dk' },
  nl: { name: 'NL', short: 'Nederlands', lan: 'Dutch', icon: 'flag-icon-nl' },
  en: { name: 'EN', short: 'English', lan: 'English', icon: 'flag-icon-gb' },
  fr: { name: 'FR', short: 'Français', lan: 'French', icon: 'flag-icon-fr' },
  de: { name: 'DE', short: 'Deutsch', lan: 'German', icon: 'flag-icon-de' },
  it: { name: 'IT', short: 'Italiano', lan: 'Italian', icon: 'flag-icon-it' },
  pl: { name: 'PL', short: 'Polski', lan: 'Polish', icon: 'flag-icon-pl' },
  pt: { name: 'PT', short: 'Português', lan: 'Portuguese', icon: 'flag-icon-pt' },
  es: { name: 'ES', short: 'Español', lan: 'Spanish', icon: 'flag-icon-es' },
};

// Generate localeOptions from SUPPORTED_LANGUAGES
export const localeOptions = Object.entries(LANGUAGE_DETAILS).map(([value, details]) => ({
  value,
  ...details,
}));

// enum used for drivers and sponsors
export enum EDefaultLanguages {
  en = 'en',
  de = 'de',
  fr = 'fr',
  it = 'it',
  nl = 'nl',
  pt = 'pt',
  es = 'es',
  da = 'da',
  lt = 'lt',
}

// enum used for drivers and sponsors
export enum EHomeCountries {
  AT = 'AT',
  BE = 'BE',
  CH = 'CH',
  CZ = 'CZ',
  DE = 'DE',
  DK = 'DK',
  ES = 'ES',
  FR = 'FR',
  IT = 'IT',
  LI = 'LI',
  LT = 'LT',
  LU = 'LU',
  NL = 'NL',
  PL = 'PL',
  PT = 'PT',
}
